var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"back-to-top",on:{"click":_vm.scrollToTop}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }